import React from 'react';

export const AllsIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
			<circle cx="15" cy="15" r="15" fill="#32D296" />
		</svg>
	);
};
